export const LTLColumns = [
    {
        name: 'Заказ №',
        key: 'number',
    },
    {
        name: 'Компания',
        key: 'company',
    },
    {
        name: 'Накладных',
        key: 'invoices_count',
    },
    {
        name: 'Менеджер',
        key: 'manager',
    },
    {
        name: 'Отправитель',
        key: 'full_name',
    },
    {
        name: 'Адрес отправителя',
        key: 'full_address',
    },
    {
        name: 'Телефон отправителя',
        key: 'phone',
    },
    {
        name: 'Доп. телефон',
        key: 'additional_phone',
    },
    {
        name: 'Дата создания',
        key: 'take_date',
    },
]

export const LTLInvoicesColumns = [
    {
        name: 'Номер накладной',
        key: 'invoice_number',
    },
    {
        name: 'Номер заказа',
        key: 'order_number',
    },
    {
        name: 'Номер накл. заказчика',
        key: 'dop_invoice_number',
        withHint: true,
    },
    {
        name: 'Комментарий получателя',
        key: 'receiver',
        customHint: 'comment',
    },
    {
        name: 'Клиент',
        key: 'company_name',
        withHint: true,
    },
    {
        name: 'Направление',
        key: 'direction',
    },
    {
        name: 'Вид перевозки',
        key: 'shipment_type',
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'НБ',
        key: 'billing_enabled',
        headerHint: 'Наличие биллинга',
    },
    {
        name: 'ПВ',
        key: 'pv',
        headerHint: 'Вычисление создано',
    },
    {
        name: 'БЛ',
        key: 'bl',
        headerHint: 'Транскрипт создан',
    },
    {
        name: 'СВ',
        key: 'is_pickup',
        headerHint: 'Самовывоз',
    },
    {
        name: 'СП',
        key: 'is_self_delivery',
        headerHint: 'Самопривоз',
    },
    {
        name: 'Доп. услуги',
        key: 'additional_services_values',
    },
    {
        name: 'Статус',
        key: 'status_name',
        withHint: true,
    },
    {
        name: 'Дата поступления в город назначения',
        key: 'date_arrival_receiver_city',
        withHint: true,
    },
    {
        name: 'Откуда',
        key: 'sender',
        customHint: 'full_address',
    },
    {
        name: 'Куда',
        key: 'receiver',
        customHint: 'full_address',
    },
    {
        name: 'Дата доставки',
        key: 'delivery_date',
        withHint: true,
    },
    {
        name: 'Дата забора',
        key: 'take_date',
    },
    {
        name: 'Стоимость доставки',
        key: 'cost_prediction',
        withHint: true,
    },
    {
        name: 'Плательщик',
        key: 'payer_company',
        withHint: true,
    },
]

export const LtlStatusColors = [
    '',
    'blue--outline',
    'blue--fill--light',
    'blue--fill',
    'red--outline',
    'yellow--outline',
    'yellow--fill',
    'orange--outline',
    'orange--fill',
    'orange--fill--light',
    'green--fill',
    'red--outline',
]
